import jwtDecode from "jwt-decode";

import { AppDispatch } from "../../store";
import { currentUserSlice } from "../CurrentUser/CurrentUserSlice";

import { getAuthToken } from "../../../../custom-hooks/useDecodedToken/useDecodedToken";
import { HrnsToken } from "../../../../models/auth/hrns-token";

export const login = () => (dispatch: AppDispatch) => {
  const token = getAuthToken();

  const tokenData: HrnsToken | null = token ? jwtDecode<HrnsToken>(token) : null;

  const exp: number | undefined = tokenData ? tokenData.exp : undefined;

  if (exp && Date.now() <= exp * 1000) dispatch(currentUserSlice.actions.setIsLoggedIn(true));
};
